import React from "react";
import MapComponent, { MapProps } from "./MapComponent";
import MapsWrapper from "../../shared/MapsWrapper";

interface REITMapsProps {
  props: MapProps;
}

const REITMaps: React.FC<REITMapsProps> = ({ props }) => {
  return (
    <div className="Maps">
      <MapsWrapper>
        <MapComponent {...props} />
      </MapsWrapper>
    </div>
  );
};

export default REITMaps;
